module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"general":"General","tms":"TMS","cancelLabel":"Cancel","save":"Save settings","title":"Settings","systemSettings":"System parameters"},"no":{"general":"Generelt","tms":"TMS","cancelLabel":"Avbryt","save":"Lagre innstillingene","title":"Innstillinger","systemSettings":"System parameterer"}}')
  delete Component.options._Ctor
}
